import { useEffect, useRef } from "react";

export const useReveal = (options = {}) => {
  const ref = useRef(null);
  const { threshold = 0.15, root = null, rootMargin = "0px" } = options;
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold, root, rootMargin }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold, root, rootMargin]);
  return ref;
};
